import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './plugins/vant'
import 'animate.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);



import axios from 'axios'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
// Vue.prototype.HOST = '/api'

new Vue({
  router,
  store,
  render: h => h(App),

}).$mount('#app')
